import { addControl, controlDetail, editControl } from './request';
import { PAGETYPE, getSplitFun } from './utils';
import { recursionCopy } from '@/views/customer/roleManage/utils';
import { controlsSource } from './../dataSourceManage/request';
export default {
  data() {
    return {
      PAGETYPE,
      dialogVisible: false,
      dataFrom: {
        controlsSourceId: [],
        remarks: ''
      },
      controlsList: []
    };
  },
  computed: {
    dataRule() {
      return {
        name: [{
          required: true,
          trigger: 'blur',
          message: this.$t('请输入') + this.$t('控件名称')
        }],
        mark: [{
          required: true,
          trigger: 'blur',
          message: this.$t('请输入') + this.$t('标识')
        }],
        pageType: [{
          required: true,
          message: this.$t('请选择') + this.$t('应用页面类型'),
          trigger: 'change'
        }]
      };
    }
  },
  methods: {
    async init(val) {
      if (val) {
        const res = await controlDetail({
          controlsId: val.id
        });
        this.dataFrom = {
          controlsId: res.id,
          name: res.name,
          mark: res.mark,
          pageType: getSplitFun(res.pageType),
          remarks: res.remarks,
          controlsSourceId: getSplitFun(res.controlsSourceId)
        };
      }
      this.controlsList = await controlsSource({});
      this.dialogVisible = true;
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    },
    handleSure() {
      this.$refs.dataFrom.validate(async valid => {
        if (valid) {
          const FUN = this.dataFrom.controlsId ? editControl : addControl;
          let formData = recursionCopy(this.dataFrom);
          if (formData.controlsSourceId.length != 0) {
            formData.controlsSourceId = formData.controlsSourceId.join(',');
          } else {
            formData.controlsSourceId = '';
          }
          formData.pageType = formData.pageType.join(',');
          await FUN(formData);
          this.$message.success(this.$t('操作成功'));
          this.$emit('save');
          this.$emit('cancel');
        }
      });
    }
  }
};